import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["dialog", "image", "caption"];

  connect() {
    this.boundBackdrop = this.handleBackdrop.bind(this);
    if (this.hasDialogTarget) {
      this.dialogTarget.addEventListener("click", this.boundBackdrop);
    }
  }

  disconnect() {
    if (this.hasDialogTarget) {
      this.dialogTarget.removeEventListener("click", this.boundBackdrop);
    }
  }

  open(event) {
    const img = event.target.closest(".bulletin-figure img");
    if (!img) return;

    this.imageTarget.src = img.src;
    this.imageTarget.alt = img.alt || "";
    this.captionTarget.textContent = img.alt || "";
    this.captionTarget.hidden = !img.alt;

    if (typeof this.dialogTarget.showModal === "function") {
      this.dialogTarget.showModal();
    } else {
      this.dialogTarget.setAttribute("open", "");
    }
  }

  close() {
    if (typeof this.dialogTarget.close === "function") {
      this.dialogTarget.close();
    } else {
      this.dialogTarget.removeAttribute("open");
    }
  }

  handleBackdrop(event) {
    if (event.target === this.dialogTarget) this.close();
  }
}
